import { Flex, Form, Input, Select, Typography } from 'antd';
import React, { useCallback, useEffect } from 'react';
import CustomModal from '../CustomModal';
import { getUsers } from '../../redux/actions/users';
import { getFullName } from '../../utils';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { assignUser } from '../../redux/actions/customer';

const { Option } = Select;

const CustomerModal = ({ open, onCancel, data }) => {
    const [form] = Form.useForm();
    const { users } = useSelector((state) => state.usersSlice);

    const handleSearch = useCallback(
        debounce(async (value) => {
            getUsers({ searchText: value, loading: false });
        }, 300),
        []
    );

    const handleSubmit = async (values) => {
        if (!values.assigned_user_id) {
            values.assigned_user_id = null;
        }
        const res = await assignUser({ user_id: data.id, body: values })
        if (res?.ack) onCancel();
    };

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                assigned_user_id: data.assigned_user_id,
            });
        }
    }, [data, form]);

    return (
        <CustomModal
            title="Customer Details"
            open={open}
            onCancel={onCancel}
            okText="Save"
            width={500}
            onOk={() => form.submit()}
        >
            <Form form={form} onFinish={handleSubmit} layout="vertical">
                <Form.Item label="Name">
                    <Input readOnly value={`(${data?.code}) ${data?.name}`} />
                </Form.Item>
                <Form.Item label="Sales Representative">
                    <Input readOnly value={data?.salesrep} />
                </Form.Item>
                <Form.Item label="Credit Controller">
                    <Input readOnly value={data?.credit_controller} />
                </Form.Item>
                <Form.Item label="Phone">
                    <Input readOnly value={data?.phone} />
                </Form.Item>
                <Form.Item name="assigned_user_id" label="Assign User">
                    <Select
                        placeholder="Assign User"
                        optionLabelProp="label"
                        style={{ width: '100%' }}
                        showSearch
                        allowClear
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        onDropdownVisibleChange={(open) => {
                            if (open && !users?.length) getUsers({ loading: false });
                        }}
                        onSearch={handleSearch}
                    >
                        {users?.map((user) => (
                            <Option key={user?.id} value={user?.id} label={getFullName(user)}>
                                <Flex vertical gap={1}>
                                    <Typography.Text>{getFullName(user)}</Typography.Text>
                                    <Typography.Text type="secondary">{user.email}</Typography.Text>
                                </Flex>
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </CustomModal>
    );
};

export default CustomerModal;
